// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"298":"b6b26c54e8b78cb6","984":"b69744bcb752c8bc"}[chunkId] + ".js";
};